module.exports = __webpack_public_path__ + "img/manschetten_btn.bea35618.jpg";